import 'babel-polyfill'
import 'es6-map/implement'
import React from 'react'
import ReactDOM from 'react-dom'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducer from './reducer'
import { TransState } from './Modules/Localization'
import { LoginModalContainer } from './Modules/PremiumPage'
import { GoogleButton } from './Modules/AppAuthPage'
import { LoginPage } from './Modules/LoginPage'


const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(
    thunkMiddleware
  ),
)

const apps = [
  {
    id: 'login-page-login-container',
    element: <LoginPage />,
  },
  {
    id: 'auth-app-google',
    element: <GoogleButton />,
  },
  {
    id: 'premium-auth-modal-container',
    element: <LoginModalContainer />,
  }
]

const loadApps = () => {
  apps.forEach((app) => {
    const el = document.getElementById(app.id)

    if (el) {
      ReactDOM.render(
        <Provider store={store}>
          <TransState>
            { app.element }
          </TransState>
        </Provider>
        , el
      )
    }
  })
}

document.addEventListener('DOMContentLoaded', loadApps)



// WEBPACK FOOTER //
// ./client/index.js